import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AuthorizationVersion = "legacy" | "keycloak";
interface AuthorizationState {
  version?: AuthorizationVersion;
  token?: string;
  refreshToken?: string;
  deviceId?: string;
  otpSessionUuid?: string;
  authSessionId?: string;
  flow?: "REG" | "AUTH";
  passportChecked: boolean;
  restoringPin: boolean;
  foreignPassport: boolean;
  epoch: number;
}

// Only completed device credentials survive a reload. Unfinished login starts at phone.
export const useAuthorizationStore = create<AuthorizationState>()(persist((): AuthorizationState => ({
  passportChecked: false,
  restoringPin: sessionStorage.getItem("keycloak-restore-pin") === "true",
  foreignPassport: false,
  epoch: 0,
}), {
  name: "authorization-store",
  partialize: ({ version, token, refreshToken, deviceId }) => ({ version, token, refreshToken, deviceId }),
}));

export const isNewAuthorization = () => useAuthorizationStore.getState().version === "keycloak";

useAuthorizationStore.subscribe(({ restoringPin }) => {
  if (restoringPin) sessionStorage.setItem("keycloak-restore-pin", "true");
  else sessionStorage.removeItem("keycloak-restore-pin");
});
